module.exports = "<div id=\"page\" [@routeAnimation]=\"getState(myOutlet)\">\n    <router-outlet #myOutlet=\"outlet\"></router-outlet>\n</div>"